import { DomHelper } from '../general/utils';
import { breakpoints } from "../_variables";

export default class Box {

  constructor() {
    let _scope = this,
      event = DomHelper.isTouchDevice() ? 'orientationchange' : 'resize';

    this.wrappers = document.querySelectorAll('.row[data-columns="2"]');
    this.init();

    window.addEventListener(event, function () {
      _scope.init();
    });
  }

  init() {
    let _scope = this;

    if(this.wrappers.length) {
      for (let wrapper of Array.from(this.wrappers)) {
        if(DomHelper.getWindowInnerWidth() >= breakpoints.breakpointmd) {
          _scope.setIdentHeight(wrapper);
        } else {
          _scope.removeIdentHeight(wrapper);
        }
      }
    }
  }

  setIdentHeight(wrapper) {
    let boxes = wrapper.getElementsByClassName('box-wrapper'),
      maxHeight,
      heights = [];

    maxHeight = 0;

    if(boxes.length > 1) {

      for (let box of Array.from(boxes)) {
        box.style.height = '';
        heights.push(box.clientHeight);
      }

      maxHeight = DomHelper.maxValueInArray(heights);

      for (let box of Array.from(boxes)) {
        box.style.height = maxHeight + 'px';
      }
    }
  }

  removeIdentHeight(wrapper) {
    let boxes = wrapper.getElementsByClassName('box-wrapper');

    for (let box of Array.from(boxes)) {
      box.style.height = '';
    }
  }
}